import { useMemo } from "react";
import { SetURLSearchParams, useSearchParams } from "react-router-dom";

const useQuery = (): { params: {}; setSearchParams: SetURLSearchParams } => {
  const [searchParams, setSearchParams] = useSearchParams();

  const params = {} as URLSearchParams;
  searchParams.forEach((value, key) => {
    Object.assign(params, { [key]: value });
  });

  return useMemo(() => ({ params, setSearchParams }), [searchParams]);
};

export default useQuery;
